// extracted by mini-css-extract-plugin
export default {"idleAnimation":"Negative-module__idleAnimation--XY5rv","runningAnimation":"Negative-module__runningAnimation--ZIjD9","copilotRun":"Negative-module__copilotRun--PYLrI"};